<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.19819 1.4375C1.89116 1.4375 1.5967 1.55947 1.3796 1.77657C1.16249 1.99367 1.04053 2.28813 1.04053 2.59516V14.1988C1.04053 14.5058 1.16249 14.8003 1.3796 15.0174C1.5967 15.2345 1.89116 15.3564 2.19819 15.3564H13.8018C14.1088 15.3564 14.4033 15.2345 14.6204 15.0174C14.8375 14.8003 14.9595 14.5058 14.9595 14.1988V2.59516C14.9595 2.28813 14.8375 1.99367 14.6204 1.77657C14.4033 1.55947 14.1088 1.4375 13.8018 1.4375H2.19819ZM0.67249 1.06946C1.07713 0.664824 1.62594 0.4375 2.19819 0.4375H13.8018C14.3741 0.4375 14.9229 0.664824 15.3275 1.06946C15.7321 1.4741 15.9595 2.02291 15.9595 2.59516V14.1988C15.9595 14.771 15.7321 15.3198 15.3275 15.7245C14.9229 16.1291 14.3741 16.3564 13.8018 16.3564H2.19819C1.62594 16.3564 1.07713 16.1291 0.67249 15.7245C0.26785 15.3198 0.0405254 14.771 0.0405254 14.1988V2.59516C0.0405254 2.02291 0.26785 1.4741 0.67249 1.06946ZM5 4.39697C5 4.94926 4.55228 5.39697 4 5.39697C3.44772 5.39697 3 4.94926 3 4.39697C3 3.84469 3.44772 3.39697 4 3.39697C4.55228 3.39697 5 3.84469 5 4.39697ZM7.5 5.39697C8.05229 5.39697 8.5 4.94926 8.5 4.39697C8.5 3.84469 8.05229 3.39697 7.5 3.39697C6.94772 3.39697 6.5 3.84469 6.5 4.39697C6.5 4.94926 6.94772 5.39697 7.5 5.39697Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppsIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
